module.exports = __webpack_public_path__ + "static/media/search-icon.33db786c.svg";